import React, { useState, useEffect } from 'react';
import { LogoLoading } from 'ensightful-koala-ui';
import Joyride from 'react-joyride';

import { useAuth } from 'contexts/auth';
import { useTask } from 'contexts/task';
import { useUser } from 'contexts/user';
import { useUser2 } from 'contexts/user2';
import { useViewport } from 'contexts/viewport';
import withResponsiveLayout from 'hoc/withResponsive';
import Mobile from 'pages/Dashboard/mobile';
import Tablet from 'pages/Dashboard/tablet';
import Desktop from 'pages/Dashboard/desktop';
import { getStatus } from 'utils/helper';
import courseService from 'services/course';
import NickelTour from 'components/organisms/Dashboard/NickelTour';
import { useTour } from 'contexts/tour';

const Dashboard = () => {
    const { auth } = useAuth();
    const { taskList, subtaskList } = useTask();
    const { getActivityList } = useUser();
    const tour = useTour();
    const {
        isLoading,
        course,
        groups,
        currentGroup,
        instructorAccountUsers,
        currentGroupAccountUsers,
        distribution,
        setDistribution,
    } = useUser2();
    const { width } = useViewport();
    const [status, setStatus] = useState();
    const [activityList, setActivityList] = useState({ total: 0, results: [] });
    const [activitySettings, setActivitySettings] = useState({ mode: 'today', max: 10 });

    const myTasks = Object.values(taskList.all).filter(({ collaborator_account_ids }) =>
        (collaborator_account_ids || []).includes(auth.owner_account_id)
    );
    const mySubtasks = Object.values(subtaskList).filter(({ collaborator_account_ids }) =>
        (collaborator_account_ids || []).includes(auth.owner_account_id)
    );

    useEffect(() => {
        if (auth) {
            const getDistribution = async () => {
                const distributions = await courseService.findCourseDistribution(auth.course_id);
                setDistribution(distributions);
            };
            getDistribution();
        }
    }, [currentGroup, taskList.all, subtaskList]);

    useEffect(() => {
        if (distribution && groups) {
            const groupStatus = getStatus(distribution, groups, auth.group_id);
            setStatus(groupStatus);
        }
    }, [distribution]);

    useEffect(() => {
        (async () => {
            const response = await getActivityList(activitySettings.mode, 0, activitySettings.max);
            setActivityList(response);
        })();
    }, [activitySettings.max, activitySettings.mode, getActivityList]);

    const props = {
        course,
        group: currentGroup,
        groupMembers: currentGroupAccountUsers,
        instructorMembers: instructorAccountUsers,
        status,
        myTasks,
        mySubtasks,
        currentAccountId: auth.owner_account_id,
        activityList: activityList,
        setActivitySettings,
    };

    const responsiveLayouts = {
        mobile: <Mobile {...props} />,
        tablet: <Tablet {...props} />,
        desktop: <Desktop {...props} />,
    };

    if (isLoading) return <LogoLoading />;
    return (
        <>
            {withResponsiveLayout(width, responsiveLayouts)}
            <NickelTour />
            <Joyride
                continuous
                callback={tour?.handleJoyrideCallback}
                stepIndex={tour?.currentStep}
                disableScrolling
                disableOverlayClose
                hideCloseButton
                run={tour?.run}
                scrollToFirstStep
                steps={tour?.steps}
                styles={{
                    options: {
                        zIndex: 10000,
                    },
                }}
            />
        </>
    );
};

export default Dashboard;
